/*jshint esversion: 6 */
/*jshint sub:true*/
import Vue from 'vue';

import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getProjectMembers: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].users;
  },
  getProjectMembersForMessage: (state, getters, rootState) => (id) => {
    let users = [];
    for (let i = 0; i < rootState.Ultra.projects[id].users.length; i++) {
      let user;
      let prole = rootState.Ultra.projects[id].users[i].prole;
      if (rootState.Ultra.projects[id].users[i].user) {
        user = rootState.Ultra.projects[id].users[i].user;
      } else {
        user = rootState.Ultra.projects[id].users[i];
      }
      users.push({
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        image: user.image,
        role_name: prole.name
      });
    }
    return users;
  },
};
// Actions
const actions = {
  requestProjectMembers({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/users?show=showProjectMembers',
          method: 'GET',
          headers: {
            'cache-control': 'no-cache'
          },
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              users: resp.data.data
            }
          };
          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  requestProjectRoles({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/proles?show=showProjectMembers',
          method: 'GET'
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              proles: resp.data.data.proles
            }
          };
          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  requestPPermissions({commit, rootState}, payload) {

    let cache_control = 'public, max-age=86400';
    if(Object.prototype.hasOwnProperty.call(payload, 'is_cached') && payload.is_cached === false){
      cache_control = 'no-cache';
    }

    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/permissions?show=showWithEntitiesNormalized',
          method: 'GET',
          headers: {
            'Cache-Control': cache_control
          },
        })
        .then(resp => {
          payload = {
            url: [
              {allppermissions: ''},
              {showWithEntitiesNormalized: ''}
            ],
            resp_data: {
              allppermissions: resp.data.data.ppermissions
            }
          };
          commit('Ultra/create_u_objects', {rootState, payload}, { root: true });
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  changeUserProjectRole({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/changeuserprole',
      method: 'PUT',
      data: payload.change
    })
    .then( () => {
      commit('change_user_project_role', {rootState, payload});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  removeUsersFromProject({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/removeusers',
      method: 'PUT',
      data: {
        users: payload.users,
      },
    })
    .then( () => {
      commit('View/setProjectMembersSelectedIndex', 0, { root: true });
      commit('remove_users_from_project', {rootState, payload});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  removePPermission({commit}, payload){
    return new Promise((resolve, reject) => {
      let ultra_payload = {
        url: [
          { projects: payload.project_id },
          { proles: payload.prole_id },
          { ppermissions: payload.ppermission_id }
        ]
      };
      commit('Ultra/remove_u_object', ultra_payload, { root: true });
      axios({
        url: 'projects/' + payload.project_id + '/proles/' + payload.prole_id + '/removepermission',
        method: 'PUT',
        data: {
          ppermission: payload.ppermission_id,
        },
      })
      .then( () => {
        resolve();
      })
      .catch(() => {
        let ultra_payload = {
          url: [
            { projects: payload.project_id }, // -4
            { proles: payload.prole_id }, // -3
            { ppermissions: payload.ppermission_id }, // -2
            { random: '' } // -1
          ],
          resp_data: { ppermissions: [{ id: payload.ppermission_id }] }
        };
        commit('Ultra/add_u_object', ultra_payload, { root: true });
        reject();
      });
    });
  },
  addPPermission({commit}, payload){
    return new Promise((resolve, reject) => {
      let ultra_payload = {
        url: [
          { projects: payload.project_id }, // -4
          { proles: payload.prole_id }, // -3
          { ppermissions: payload.ppermission_id }, // -2
          { random: '' } // -1
        ],
        resp_data: { ppermissions: [{ id: payload.ppermission_id }] }
      };
      commit('Ultra/add_u_object', ultra_payload, { root: true });
      axios({
        url: 'projects/' + payload.project_id + '/proles/' + payload.prole_id + '/addpermission',
        method: 'PUT',
        data: {
          ppermission: payload.ppermission_id,
        },
      })
      .then( () => {
        resolve();
      })
      .catch(() => {
        let ultra_payload = {
          url: [
            { projects: payload.project_id },
            { proles: payload.prole_id },
            { ppermissions: payload.ppermission_id }
          ]
        };
        commit('Ultra/remove_u_object', ultra_payload, { root: true });
        reject();
      });
    });
  },
};
// Mutations
const mutations = {
  //Mutations mutating Ultra store
  change_user_project_role(state, {rootState, payload}) {
    let prole = rootState.Ultra.proles[payload.change.prole];
    for (let i = 0; i < rootState.Ultra.projects[payload.project_id].users.length; i++) {
      if (rootState.Ultra.projects[payload.project_id].users[i].id === payload.change.user) {
        Vue.set(rootState.Ultra.projects[payload.project_id].users[i], 'prole', prole);
      }
    }
  },
  remove_users_from_project(state, {rootState, payload}){
    function getIndex(id){
      return rootState.Ultra.projects[payload.project_id].users.findIndex(function(item) {
        return item.id == id;
      });
    }
    for (let i = 0; i < payload.users.length; i++) {
      rootState.Ultra.projects[payload.project_id].users.splice(getIndex(payload.users[i].id), 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
